var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/ButtonExtension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { goTo } from "@adornis/router/client/open-href.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseButton } from "../../db/extensions/BaseButton.js";
import "../components/x-buildify-permission-selection.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var ButtonExtension = {
  class: BaseButton,
  toolbar: { icon: "gamepad", text: { default: "Button" } },
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-button-extension
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-button-extension>
    `;
  },
  editor({ host, content, contentController, controllerBaseKeyPath }) {
    return html`
      <x-flex space="md">
        <x-input placeholder="Text" ${contentController.field(...controllerBaseKeyPath, "text")}></x-input>
        <x-input
          placeholder="URL"
          ${contentController.field(...controllerBaseKeyPath, "href")}
          icon="open_in_browser"
          @icon-click=${() => {
      if (content.href)
        goTo(content.href);
      contentController.validate();
    }}
        >
        </x-input>
        <x-dropdown-selection
          placeholder="Wo soll der Link aufgehen?"
          ${contentController.field(...controllerBaseKeyPath, "target")}
          .selectables=${["_self", "_blank"]}
          .renderString=${(target) => target ? { _self: "Im aktuellen Fenster", _blank: "In einem neuen Fenster" }[target] ?? "" : ""}
        ></x-dropdown-selection>
        <x-checkbox
          label="Button auf voller Breite?"
          ${contentController.field(...controllerBaseKeyPath, "fullWidth")}
        ></x-checkbox>
        <x-input placeholder="Icon" ${contentController.field(...controllerBaseKeyPath, "icon")}></x-input>
        <x-dropdown-selection
          placeholder="Button-Modus"
          .selectables=${["action", "outline", "text"]}
          ${contentController.field(...controllerBaseKeyPath, "mode")}
          .renderString=${(str) => str ? { action: "Prim\xE4r", outline: "Sekund\xE4r", text: "Text" }[str] ?? "" : ""}
        ></x-dropdown-selection>
      </x-flex>
    `;
  },
  group: "Basics"
};
var XButtonExtension = class extends ExtensionBoilerplate {
  _content(content) {
    return xComponents(
      html`
        <x-button
          href=${content.href}
          target=${content.target}
          mode=${content.mode ?? "action"}
          icon=${content.icon ?? ""}
          ${css({ width: content.fullWidth ? "100%" : "" })}
        >
          ${content.text}</x-button
        >
      `
    );
  }
  styles() {
    return [...super.styles(), { ":host": { width: this.content.value?.fullWidth ? "100%" : "" } }];
  }
};
XButtonExtension = __decorateClass([
  customElement("x-button-extension")
], XButtonExtension);
export {
  ButtonExtension,
  XButtonExtension
};
